module.exports = __webpack_public_path__ + "media/images/assignment/preview_white-9d18a42ae8e7b53132b2e98e23e61bde.svg";